<p class="success">
  <slot />
</p>

<style>
  .success {
    color: #0fa60b;
  }
</style>
